module.exports = __webpack_public_path__ + "media/assets/player/esc-a50da4e95b59bf69a0c9fb30cadbeff1.png";